<template>
    <div class="mt-3 flex items-center justify-between">
        <div class="text-gray-800">
            Gift Card &mdash;
            <span class="text-gray-600">{{ giftCard.token }}</span>
        </div>
        <span class="text-gray-800">
            {{ amountFormatted }}
        </span>
    </div>
</template>

<script setup lang="ts">
import type { GiftCardPaymentInfo } from '~/components/Checkout/Sections/PaymentInformation.vue'
import { computed } from 'vue'
import { Decimal } from '~/composables/support/decimal'

const props = defineProps<{
    giftCard: GiftCardPaymentInfo
}>()

const amountFormatted = computed(() => {
    return new Decimal(props.giftCard.amount)
        .invertSign()
        .formatCurrency(2, false)
})
</script>
